module.exports = __webpack_public_path__ + "img/data-management.2c0004c1.png";